import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { ThemeProvider as JssThemeProvider } from 'react-jss';
import { F5Theme } from './theme/f5';
import CssBaseline from '@mui/material/CssBaseline';
import { AppProvider } from './contexts/app';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './lib/query-client';
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ModalProvider } from './contexts/modal';
import RouteProvider from './router/provider';
import { initDatadog } from './lib/datadog';
import Environment from './lib/environment';
import ErrorBoundary from './components/error-boundary';
import { HotkeysProvider } from 'react-hotkeys-hook';
import { EmitterProvider } from './contexts/emitter';
import { printConsoleBanner } from './lib/helpers';
import { FeatureProvider } from './contexts/feature';

initDatadog();
printConsoleBanner();
console.log(`build v${APP_VERSION}-${Environment.MODE}`);

// F5 is the active scheme; SurePathTheme is kept for a future scheme switch.
const theme = createTheme(F5Theme);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MuiThemeProvider theme={theme}>
      <JssThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CssBaseline />
          <ErrorBoundary>
            <AppProvider>
              <EmitterProvider>
                <QueryClientProvider client={queryClient}>
                  <FeatureProvider>
                    <HotkeysProvider>
                      <ModalProvider>
                        <SnackbarProvider>
                          <RouteProvider />
                        </SnackbarProvider>
                      </ModalProvider>
                    </HotkeysProvider>
                  </FeatureProvider>
                </QueryClientProvider>
              </EmitterProvider>
            </AppProvider>
          </ErrorBoundary>
        </LocalizationProvider>
      </JssThemeProvider>
    </MuiThemeProvider>
  </React.StrictMode>
);
